<div class="oo-list-header">
  <h2>{{ title() }}</h2>
  @if (actionText()) {
    <button (click)="actionClicked.emit()"
            mat-stroked-button>
      {{ actionText() }}
    </button>
  }
</div>
